import type { CameraPose } from './camera-plan';
import { DEFAULT_VERTICAL_FIELD_OF_VIEW } from './night-hawk-optics';

/** Blends evaluated moving views in Mercator space and takes the shortest heading path. */
export function blendCameraPoses(from: CameraPose, to: CameraPose, t: number): CameraPose {
  const mix = (a: number, b: number) => a + (b - a) * t;
  const turn = (a: number, b: number) => a + (((b - a) % 360 + 540) % 360 - 180) * t;
  const projected = (latitude: number) => Math.log(Math.tan(Math.PI / 4 + Math.max(-85.051129, Math.min(85.051129, latitude)) * Math.PI / 360));
  const latitude = (Math.atan(Math.exp(mix(projected(from.center[1]), projected(to.center[1])))) - Math.PI / 4) * 360 / Math.PI;
  const longitude = ((turn(from.center[0], to.center[0]) + 540) % 360) - 180;
  return { ...to, ...((from.roll !== undefined || to.roll !== undefined) ? { roll: turn(from.roll ?? 0, to.roll ?? 0) } : {}),
    ...((from.fieldOfView !== undefined || to.fieldOfView !== undefined) ? { fieldOfView: mix(from.fieldOfView ?? DEFAULT_VERTICAL_FIELD_OF_VIEW, to.fieldOfView ?? DEFAULT_VERTICAL_FIELD_OF_VIEW) } : {}),
    center: [longitude, latitude], bearing: ((turn(from.bearing, to.bearing) + 540) % 360) - 180,
    pitch: mix(from.pitch, to.pitch), zoom: mix(from.zoom, to.zoom) };
}
